<!-- Toolbar Content -->
<p-toolbar class="p-0 overflow-auto max-w-full">
  <ng-content></ng-content>
</p-toolbar>